<template>
  <div class="check-right-info"
       v-if="this.type != 'checkres'">
    <div>
      <h3 class="check-title fontColor">{{curCheckInfo.Title}}</h3>
      <p class="check-info fontColor">{{curCheckInfo.Info1}}<br>{{curCheckInfo.Info2}}<br>{{curCheckInfo.Info3}}</p>
      <p class="check-notice">{{curCheckInfo.Notice}}</p>
    </div>
  </div>
  <div v-else
       class="check-result end-result">
    <ul class="check-result-list">
      <li v-for="d in checkRes"
          :key="d.name" class="fontColor">
        <p>{{d.name}}</p>
        <p v-if="d.isPass">{{$t('check.normal')}}</p>
        <p v-else
           class="check-result-abnormal">{{$t('check.abnormal')}}</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    type: String,
    errs: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      curCheckInfo: {
        Title: null,
        Info1: null,
        Info2: null,
        Info3: null,
        Notice: null
      },
      checkRes: []
    }
  },
  watch: {
    'type': {
      handler () {
        this.init()
      }
    }
  },
  computed: {
    VideoInputDeviceId () {
      return this.$store.getters.VideoInputDeviceId
    },
    AudioInputDeviceId () {
      return this.$store.getters.AudioInputDeviceId
    },
    AudioOutputDeviceId () {
      return this.$store.getters.AudioOutputDeviceId
    },
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      for (let key in this.curCheckInfo) {
        this.curCheckInfo[key] = this.$t(`check['no${this.type}${key}']`)
      }
      this.checkRes = [{
        name: this.$t('check.camera'),
        isPass: !this.errs.includes('camera')
      }, {
        name: this.$t('check.mic'),
        isPass: !this.errs.includes('mic')
      }, {
        name: this.$t('check.speaker'),
        isPass: !this.errs.includes('speaker')
      }]
    }
  },
}
</script>

<style  scoped lang="scss">

.check-right-info {
  > div {
    padding-left: 39px;
  }
  .check-title {
    color: $white-color;
    font-size: 16px;
  }
  .check-info {
    color: $white-color;
    margin: 16px 0px 24px 0px;
    font-size: 14px;
    line-height: 20px;
  }
  .check-notice {
    color: $gray6-color;
    font-size: 14px;
    width: 274px;
  }
}
.check-result {
  .check-result-list {
    > li {
      color: $white-color;
      display: flex;
      justify-content: space-between;
      margin-top: 18px;
    }
    .check-result-abnormal {
      color: $red-color;
    }
  }
}
</style>